module.exports = __webpack_public_path__ + "static/media/book.6ea27967.svg";